import 'react';
import { pm2SitemapStore, shouldTerminateMegaMenu } from '@pm2/sitemap-utils';
import { selectIsFavouritesEnabled, useToggleFavouriteMutation } from '@pm2/user-area';
import { useTrackingManager } from '@provider/tracking';
import { useUserIdentityState } from '@provider/user-identity';
import { Tooltip } from '@ui/kit';
import { HeartIcon } from '@ui/kit/icons';
import { button, icon } from './atom.favourite-button.style.js';
import { jsx } from 'react/jsx-runtime';

const SUPPORTED_DESCRIPTOR_TYPES = new Set(["Page", "Course"]);
function FavouriteButton(props) {
  const tracker = useTrackingManager();
  const isLoggedIn = useUserIdentityState(state => !!state.user);
  const isEnabled = pm2SitemapStore.useSelector(selectIsFavouritesEnabled);
  const descriptor = props.descriptor.type === "Course" ? {
    type: "course",
    version: "1",
    courseId: props.descriptor.id
  } : {
    type: "page",
    version: "1",
    pageId: props.descriptor.id
  };
  const {
    addMutation,
    deleteMutation,
    isFavourite
  } = useToggleFavouriteMutation(descriptor);
  const handleToggle = evt => {
    evt.preventDefault();
    evt.stopPropagation();
    if (addMutation.isPending || deleteMutation.isPending) {
      return;
    }
    const trackingContext = {
      context: "megamenu",
      targetId: props.descriptor?.id,
      targetPath: props.descriptor?.path ?? "",
      targetTitle: props.descriptor?.title ?? "",
      targetType: props.descriptor.type ?? "Page"
    };
    if (isFavourite) {
      deleteMutation.mutate();
      tracker.trackEvent("userarea.favourites.delete", trackingContext);
    } else {
      addMutation.mutate();
      tracker.trackEvent("userarea.favourites.add", trackingContext);
    }
  };
  if (!isLoggedIn || !isEnabled || !shouldTerminateMegaMenu(props.descriptor) || !SUPPORTED_DESCRIPTOR_TYPES.has(props.descriptor.type)) {
    return null;
  }
  return /*#__PURE__*/jsx(Tooltip, {
    ariaType: "label",
    placement: "top",
    body: isFavourite ? "Fjern fra favoritter" : "Tilføj til favoritter",
    children: ref => /*#__PURE__*/jsx("button", {
      ref: ref,
      className: button,
      onClick: handleToggle,
      children: /*#__PURE__*/jsx(HeartIcon, {
        className: icon,
        "data-favourite": isFavourite
      })
    })
  });
}

export { FavouriteButton };
//# sourceMappingURL=atom.favourite-button.js.map
